import { render } from "./UserServe.vue?vue&type=template&id=880d4e28"
import script from "./UserServe.vue?vue&type=script&lang=js"
export * from "./UserServe.vue?vue&type=script&lang=js"

import "./UserServe.vue?vue&type=style&index=0&id=880d4e28&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__